import React, { useState } from "react";
import logo from "../../assets/navbar/Logo.png";
import { Link } from "react-router-dom";
import { Menu, X , ChevronDown} from "lucide-react";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const navLinks = [
    { name: "Home", path: "/#home" },
    { name: "About", path: "/#about" },
    { name: "Services", path: "/#services" },
    { name: "Projects", path: "/#projects" },
    { name: "Blog", path: "/#blog" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <nav className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            src={logo}
            alt="Solar Energy Logo"
            className="h-12 w-auto object-contain sm:h-14 lg:h-16"
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6 lg:gap-8">
          {navLinks.map((link, index) => {
            if (link.name === "Services") {
              return (
                <div
                  key={index}
                  className="relative group"
                  onMouseEnter={() => setServicesOpen(true)}
                  onMouseLeave={() => setServicesOpen(false)}
                >
                  <div key={index} className="relative group">

                {/* Services Button */}
                <button className="flex items-center gap-1 text-base font-medium text-slate-600 transition hover:text-emerald-950">
                  Services
                  <ChevronDown
                    size={18}
                    className="transition-transform duration-300 group-hover:rotate-180"
                  />
                </button>

                {/* Dropdown */}
                <div className="absolute left-0 top-full pt-3 invisible opacity-0 translate-y-2 transition-all duration-300 group-hover:visible group-hover:opacity-100 group-hover:translate-y-0 z-50">
                  
                  <div className="w-56 rounded-xl border border-gray-100 bg-white shadow-xl py-2">
                    
                    <Link
                      to="solar-epc-services"
                      className="block px-4 py-3 text-sm text-slate-700 hover:bg-gray-100"
                    >
                      Solar EPC Solutions
                    </Link>

                    <Link
                      to="solar-plant-management"
                      className="block px-4 py-3 text-sm text-slate-700 hover:bg-gray-100"
                    >
                      Solar Plant Management
                    </Link>

                    <Link
                      to="solar-operation-and-maintenance-services"
                      className="block px-4 py-3 text-sm text-slate-700 hover:bg-gray-100"
                    >
                      Operation & Maintenance
                    </Link>

                    <Link
                      to="solar-battery-storage-services"
                      className="block px-4 py-3 text-sm text-slate-700 hover:bg-gray-100"
                    >
                      Battery Energy Storage System
                    </Link>
                    <Link
                      to="solar-pump-services"
                      className="block px-4 py-3 text-sm text-slate-700 hover:bg-gray-100"
                    >
                      Solar Pump
                    </Link>
                    <Link
                      to="solar-panel-cleaning-robot-services"
                      className="block px-4 py-3 text-sm text-slate-700 hover:bg-gray-100"
                    >
                      Solar Panel Cleaning Robots
                    </Link>
                    <Link
                      to="third-party-solar-power-purchase-services"
                      className="block px-4 py-3 text-sm text-slate-700 hover:bg-gray-100"
                    >
                      Third Party Power Purchase
                    </Link>
                  </div>
                </div>
              </div>
                </div>
              );
            }

            return (
              <Link
                key={index}
                to={link.path}
                className="text-base font-medium text-slate-600 transition hover:text-emerald-950"
              >
                {link.name}
              </Link>
            );
          })}
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-3">
          {/* CTA */}
          <Link
            to="/contact"
            className="hidden sm:inline-block rounded-lg bg-emerald-950 px-4 py-2 text-sm font-semibold text-white transition hover:bg-emerald-900"
          >
            Get Quote
          </Link>

          {/* Hamburger */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}

        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="flex flex-col gap-4 px-6 py-4 bg-white border-t">
            {navLinks.map((link, index) => {
              if (link.name === "Services") {
                return (
                  <div key={index} className="flex flex-col">
                    {/* Services Button */}
                    <button
                      onClick={() => setServicesOpen(!servicesOpen)}
                      className="flex items-center justify-between text-base font-medium text-slate-700 hover:text-emerald-950"
                    >
                      Services
                      <ChevronDown
                        size={18}
                        className={`transition-transform duration-300 ${
                          servicesOpen ? "rotate-180" : ""
                        }`}
                      />
                    </button>

                    {/* Dropdown Items */}
                    <div
                      className={`overflow-hidden transition-all duration-300 ${
                        servicesOpen
                          ? "max-h-60 opacity-100 mt-3"
                          : "max-h-0 opacity-0"
                      }`}
                    >
                      <div className="ml-4 flex flex-col gap-3 border-l border-gray-200 pl-4">
                        <Link
                          to="solar-epc-services"
                          onClick={() => setIsOpen(false)}
                          className="text-sm text-slate-600 hover:text-emerald-950"
                        >
                          Solar EPC Solutions
                        </Link>

                        <Link
                          to="solar-plant-management"
                          onClick={() => setIsOpen(false)}
                          className="text-sm text-slate-600 hover:text-emerald-950"
                        >
                          Solar Plant Management
                        </Link>

                        <Link
                          to="solar-operation-and-maintenance-services"
                          onClick={() => setIsOpen(false)}
                          className="text-sm text-slate-600 hover:text-emerald-950"
                        >
                          Operation & Maintenance
                        </Link>

                        <Link
                          to="solar-battery-storage-services"
                          onClick={() => setIsOpen(false)}
                          className="text-sm text-slate-600 hover:text-emerald-950"
                        >
                          Battery Energy Storage System
                        </Link>
                        <Link
                          to="solar-pump-services"
                          onClick={() => setIsOpen(false)}
                          className="text-sm text-slate-600 hover:text-emerald-950"
                        >
                          Solar Pump
                        </Link>
                        <Link
                          to="solar-panel-cleaning-robot-services"
                          onClick={() => setIsOpen(false)}
                          className="text-sm text-slate-600 hover:text-emerald-950"
                        >
                          Solar Panel Cleaning Robots
                        </Link>
                        <Link
                          to="third-party-solar-power-purchase-services"
                          onClick={() => setIsOpen(false)}
                          className="text-sm text-slate-600 hover:text-emerald-950"
                        >
                          Third Party Power Purchase
                        </Link>
                        
                      </div>
                    </div>
                  </div>
                );
              }

              return (
                <Link
                  key={index}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className="text-base font-medium text-slate-700 hover:text-emerald-950"
                >
                  {link.name}
                </Link>
              );
            })}

            {/* Mobile CTA */}
            <Link
              to="/#consultation"
              onClick={() => setIsOpen(false)}
              className="mt-2 rounded-lg bg-emerald-950 px-4 py-2 text-center text-sm font-semibold text-white hover:bg-emerald-900"
            >
              Get Quote
            </Link>
          </div>
        </div>
    </nav>
  );
}
export default Navbar;